// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./fonts/Satoshi-Variable.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter&family=Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,100;1,300;1,400;1,500;1,700&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.font-inter {
  font-family: "Inter", sans-serif;
}
.font-roboto {
  font-family: "Roboto", sans-serif;
}
@font-face {
  font-family: satoshi;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

.satoshi {
  font-family: satoshi, sans-serif !important;
}

body {
  font-family: satoshi, sans-serif !important;
  font-weight: 600;
}
.base_link {
  color: #1b263b;
}

.blink-animation {
  animation: blink 1s ease-in both infinite;
  transition: all 0.1s ease;
}

.base_linkDashboard {
  color: #1b263b;
  font-family: satoshi;
}

@keyframes blink {
  0% {
    opacity: 0.9;
    transform: scale(1);
  }
  50% {
    opacity: 1;
    transform: scale(1.05);
  }
  100% {
    opacity: 0.9;
    transform: scale(1.15);
  }
}

.base_link:hover {
  color: orange !important;
}

.nav-link {
  color: #1b263b;
  transition: color 0.3s;
  padding-bottom: 1rem;
  border-bottom: 2px solid transparent;
}

.base_linkFooter {
  color: white;
}

.base_linkFooter:hover {
  color: orange !important;
}

.activeLinkFooter {
  border-bottom: 2px solid white;
  padding-bottom: 1rem;
  text-align: center;
  font-weight: bold;
}

.socialMediaIcon:hover {
  color: orange !important;
  cursor: pointer;
}

.activeLink {
  padding-bottom: 0.2rem;
  text-align: center;
  font-weight: bold;
  border-bottom: 2px solid #3b5ef9;
  color: #3b5ef9;
}

.brand-product-name {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  overflow: hidden;
  text-overflow: ellipsis;
}
.table-product-desc {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* .sidebar-css {
    overflow-y: auto;
    overflow-x: hidden;
    transition: 0.3s ease-in-out;
}

.sidebar-css ::-webkit-scrollbar-track {
    background: orange;
    width: 10px;
    height: 10px;
}

.sidebar-css ::-webkit-scrollbar {
    width: 5px;
    height: 5px;
    margin: 10px;
} */

/* Target the scrollbar thumb (the draggable part) */
/* .sidebar-css::-webkit-scrollbar-thumb {
    background-color: #b9b9b9;
    border-radius: 5px;
    margin: 2px !important;
} */

/* Target the scrollbar track when the thumb is being hovered */
/* .sidebar-css::-webkit-scrollbar-thumb:hover {
    background-color: #aaaaaa;
} */

.sidebar-css::-webkit-scrollbar {
  width: 12px;
}

.sidebar-css::-webkit-scrollbar-track {
  background: white; /* color of the tracking area */
}

.sidebar-css::-webkit-scrollbar-thumb {
  background-color: #b9b9b9;
  border-radius: 20px;
  border: 3px solid white;
  cursor: pointer;
}
.MuiTableRow-root td:first-child {
  border-top-left-radius: 10px;
  border-bottom-left-radius: 10px;
}

.MuiTableRow-root td:last-child {
  border-top-right-radius: 10px;
  border-bottom-right-radius: 10px;
}

.sidebar-css::-webkit-scrollbar-thumb:hover {
  background-color: #aaaaaa;
  border-radius: 20px;
  border: 2px solid white;
}
.sidebar-css_review::-webkit-scrollbar {
  width: 0px;
}
.hover_state {
  transition: all 1s;
  border-radius: 100%;
  padding: 2px;
  box-sizing: content-box;
}
.hover_state:hover {
  background-color: #4265ff43;
}
.sidebar-css_review::-webkit-scrollbar-track {
  background: white; /* color of the tracking area */
}
.sidebar-css-new::-webkit-scrollbar {
  width: 1px !important;
  height: 5px; /* Set the width of the scrollbar to 2px */
}

.sidebar-css-new::-webkit-scrollbar-track {
  background: transparent !important;
  /* Make the scrollbar track transparent */
}

.sidebar-css-new::-webkit-scrollbar-thumb {
  background-color: rgb(
    172,
    172,
    172
  ) !important; /* Set the background color to light blue */
  border-radius: 10px;
  height: 5px;
  border: 1px solid white;
  cursor: pointer;
}

.sidebar-css_review::-webkit-scrollbar-thumb {
  background-color: #b9b9b9;
  border-radius: 20px;
  height: 10px;
  border: 3px solid white;
  cursor: pointer;
}

.sidebar-css_review::-webkit-scrollbar-thumb:hover {
  background-color: #aaaaaa;
  border-radius: 20px;
  border: 2px solid white;
}
.MuiDrawer-root {
  transition: width 0.3s ease-in-out;
}

/* Media query for small screens */
@media (max-width: 768px) {
  .MuiDrawer-root {
    width: 70%; /* Adjust the width as needed */
  }
}

.App {
  font-family: sans-serif;
  text-align: center;
}

.horizontal-slider {
  height: 20px;
}

.example-thumb-0 {
  text-align: center;
  background-color: white;
  color: transparent;
  border: 2px solid red;
  border-radius: 50%;
}

.example-thumb-1 {
  text-align: center;
  background-color: white;
  color: transparent;
  border: 2px solid green;
  border-radius: 50%;
}

.example-track {
  background: linear-gradient(to right, #ccc, #ff747b);
  border-radius: 10px;
}

.example-track.example-track-1 {
  background: linear-gradient(
    90deg,
    #ff747b 10%,
    #00b4d8 50.65%,
    #c0d288 100.3%
  );
}

.example-track.example-track-2 {
  background: #ddd;
}

.horizontal-slider .example-track {
  height: 10px;
}

.horizontal-slider .example-thumb {
  width: 20px;
  height: 20px;
  top: -5px;
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAEA;EACE,gCAAgC;AAClC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,oBAAoB;EACpB,4CAAwC;AAC1C;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,2CAA2C;EAC3C,gBAAgB;AAClB;AACA;EACE,cAAc;AAChB;;AAEA;EACE,yCAAyC;EACzC,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE;IACE,YAAY;IACZ,mBAAmB;EACrB;EACA;IACE,UAAU;IACV,sBAAsB;EACxB;EACA;IACE,YAAY;IACZ,sBAAsB;EACxB;AACF;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,cAAc;EACd,sBAAsB;EACtB,oBAAoB;EACpB,oCAAoC;AACtC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,8BAA8B;EAC9B,oBAAoB;EACpB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,wBAAwB;EACxB,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;EACjB,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,4BAA4B;EAC5B,qBAAqB;EACrB,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,oBAAoB;EACpB,4BAA4B;EAC5B,qBAAqB;EACrB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;;;;;;;;;;;;;;;;GAgBG;;AAEH,oDAAoD;AACpD;;;;GAIG;;AAEH,+DAA+D;AAC/D;;GAEG;;AAEH;EACE,WAAW;AACb;;AAEA;EACE,iBAAiB,EAAE,+BAA+B;AACpD;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;AACA;EACE,4BAA4B;EAC5B,+BAA+B;AACjC;;AAEA;EACE,6BAA6B;EAC7B,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,UAAU;AACZ;AACA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,uBAAuB;AACzB;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,iBAAiB,EAAE,+BAA+B;AACpD;AACA;EACE,qBAAqB;EACrB,WAAW,EAAE,0CAA0C;AACzD;;AAEA;EACE,kCAAkC;EAClC,yCAAyC;AAC3C;;AAEA;EACE;;;;cAIY,EAAE,2CAA2C;EACzD,mBAAmB;EACnB,WAAW;EACX,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,YAAY;EACZ,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,kCAAkC;AACpC;;AAEA,kCAAkC;AAClC;EACE;IACE,UAAU,EAAE,+BAA+B;EAC7C;AACF;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,kBAAkB;EAClB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,kBAAkB;EAClB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,oDAAoD;EACpD,mBAAmB;AACrB;;AAEA;EACE;;;;;GAKC;AACH;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,SAAS;AACX","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Inter&family=Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,100;1,300;1,400;1,500;1,700&display=swap\");\r\n\r\n.font-inter {\r\n  font-family: \"Inter\", sans-serif;\r\n}\r\n.font-roboto {\r\n  font-family: \"Roboto\", sans-serif;\r\n}\r\n@font-face {\r\n  font-family: satoshi;\r\n  src: url(\"./fonts/Satoshi-Variable.ttf\");\r\n}\r\n\r\n.satoshi {\r\n  font-family: satoshi, sans-serif !important;\r\n}\r\n\r\nbody {\r\n  font-family: satoshi, sans-serif !important;\r\n  font-weight: 600;\r\n}\r\n.base_link {\r\n  color: #1b263b;\r\n}\r\n\r\n.blink-animation {\r\n  animation: blink 1s ease-in both infinite;\r\n  transition: all 0.1s ease;\r\n}\r\n\r\n.base_linkDashboard {\r\n  color: #1b263b;\r\n  font-family: satoshi;\r\n}\r\n\r\n@keyframes blink {\r\n  0% {\r\n    opacity: 0.9;\r\n    transform: scale(1);\r\n  }\r\n  50% {\r\n    opacity: 1;\r\n    transform: scale(1.05);\r\n  }\r\n  100% {\r\n    opacity: 0.9;\r\n    transform: scale(1.15);\r\n  }\r\n}\r\n\r\n.base_link:hover {\r\n  color: orange !important;\r\n}\r\n\r\n.nav-link {\r\n  color: #1b263b;\r\n  transition: color 0.3s;\r\n  padding-bottom: 1rem;\r\n  border-bottom: 2px solid transparent;\r\n}\r\n\r\n.base_linkFooter {\r\n  color: white;\r\n}\r\n\r\n.base_linkFooter:hover {\r\n  color: orange !important;\r\n}\r\n\r\n.activeLinkFooter {\r\n  border-bottom: 2px solid white;\r\n  padding-bottom: 1rem;\r\n  text-align: center;\r\n  font-weight: bold;\r\n}\r\n\r\n.socialMediaIcon:hover {\r\n  color: orange !important;\r\n  cursor: pointer;\r\n}\r\n\r\n.activeLink {\r\n  padding-bottom: 0.2rem;\r\n  text-align: center;\r\n  font-weight: bold;\r\n  border-bottom: 2px solid #3b5ef9;\r\n  color: #3b5ef9;\r\n}\r\n\r\n.brand-product-name {\r\n  display: -webkit-box;\r\n  -webkit-box-orient: vertical;\r\n  -webkit-line-clamp: 3;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n}\r\n.table-product-desc {\r\n  display: -webkit-box;\r\n  -webkit-box-orient: vertical;\r\n  -webkit-line-clamp: 1;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n}\r\n\r\n/* .sidebar-css {\r\n    overflow-y: auto;\r\n    overflow-x: hidden;\r\n    transition: 0.3s ease-in-out;\r\n}\r\n\r\n.sidebar-css ::-webkit-scrollbar-track {\r\n    background: orange;\r\n    width: 10px;\r\n    height: 10px;\r\n}\r\n\r\n.sidebar-css ::-webkit-scrollbar {\r\n    width: 5px;\r\n    height: 5px;\r\n    margin: 10px;\r\n} */\r\n\r\n/* Target the scrollbar thumb (the draggable part) */\r\n/* .sidebar-css::-webkit-scrollbar-thumb {\r\n    background-color: #b9b9b9;\r\n    border-radius: 5px;\r\n    margin: 2px !important;\r\n} */\r\n\r\n/* Target the scrollbar track when the thumb is being hovered */\r\n/* .sidebar-css::-webkit-scrollbar-thumb:hover {\r\n    background-color: #aaaaaa;\r\n} */\r\n\r\n.sidebar-css::-webkit-scrollbar {\r\n  width: 12px;\r\n}\r\n\r\n.sidebar-css::-webkit-scrollbar-track {\r\n  background: white; /* color of the tracking area */\r\n}\r\n\r\n.sidebar-css::-webkit-scrollbar-thumb {\r\n  background-color: #b9b9b9;\r\n  border-radius: 20px;\r\n  border: 3px solid white;\r\n  cursor: pointer;\r\n}\r\n.MuiTableRow-root td:first-child {\r\n  border-top-left-radius: 10px;\r\n  border-bottom-left-radius: 10px;\r\n}\r\n\r\n.MuiTableRow-root td:last-child {\r\n  border-top-right-radius: 10px;\r\n  border-bottom-right-radius: 10px;\r\n}\r\n\r\n.sidebar-css::-webkit-scrollbar-thumb:hover {\r\n  background-color: #aaaaaa;\r\n  border-radius: 20px;\r\n  border: 2px solid white;\r\n}\r\n.sidebar-css_review::-webkit-scrollbar {\r\n  width: 0px;\r\n}\r\n.hover_state {\r\n  transition: all 1s;\r\n  border-radius: 100%;\r\n  padding: 2px;\r\n  box-sizing: content-box;\r\n}\r\n.hover_state:hover {\r\n  background-color: #4265ff43;\r\n}\r\n.sidebar-css_review::-webkit-scrollbar-track {\r\n  background: white; /* color of the tracking area */\r\n}\r\n.sidebar-css-new::-webkit-scrollbar {\r\n  width: 1px !important;\r\n  height: 5px; /* Set the width of the scrollbar to 2px */\r\n}\r\n\r\n.sidebar-css-new::-webkit-scrollbar-track {\r\n  background: transparent !important;\r\n  /* Make the scrollbar track transparent */\r\n}\r\n\r\n.sidebar-css-new::-webkit-scrollbar-thumb {\r\n  background-color: rgb(\r\n    172,\r\n    172,\r\n    172\r\n  ) !important; /* Set the background color to light blue */\r\n  border-radius: 10px;\r\n  height: 5px;\r\n  border: 1px solid white;\r\n  cursor: pointer;\r\n}\r\n\r\n.sidebar-css_review::-webkit-scrollbar-thumb {\r\n  background-color: #b9b9b9;\r\n  border-radius: 20px;\r\n  height: 10px;\r\n  border: 3px solid white;\r\n  cursor: pointer;\r\n}\r\n\r\n.sidebar-css_review::-webkit-scrollbar-thumb:hover {\r\n  background-color: #aaaaaa;\r\n  border-radius: 20px;\r\n  border: 2px solid white;\r\n}\r\n.MuiDrawer-root {\r\n  transition: width 0.3s ease-in-out;\r\n}\r\n\r\n/* Media query for small screens */\r\n@media (max-width: 768px) {\r\n  .MuiDrawer-root {\r\n    width: 70%; /* Adjust the width as needed */\r\n  }\r\n}\r\n\r\n.App {\r\n  font-family: sans-serif;\r\n  text-align: center;\r\n}\r\n\r\n.horizontal-slider {\r\n  height: 20px;\r\n}\r\n\r\n.example-thumb-0 {\r\n  text-align: center;\r\n  background-color: white;\r\n  color: transparent;\r\n  border: 2px solid red;\r\n  border-radius: 50%;\r\n}\r\n\r\n.example-thumb-1 {\r\n  text-align: center;\r\n  background-color: white;\r\n  color: transparent;\r\n  border: 2px solid green;\r\n  border-radius: 50%;\r\n}\r\n\r\n.example-track {\r\n  background: linear-gradient(to right, #ccc, #ff747b);\r\n  border-radius: 10px;\r\n}\r\n\r\n.example-track.example-track-1 {\r\n  background: linear-gradient(\r\n    90deg,\r\n    #ff747b 10%,\r\n    #00b4d8 50.65%,\r\n    #c0d288 100.3%\r\n  );\r\n}\r\n\r\n.example-track.example-track-2 {\r\n  background: #ddd;\r\n}\r\n\r\n.horizontal-slider .example-track {\r\n  height: 10px;\r\n}\r\n\r\n.horizontal-slider .example-thumb {\r\n  width: 20px;\r\n  height: 20px;\r\n  top: -5px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
